import React from 'react';
import AppCard from './AppCard';
import './AppGrid.css';

const AppGrid = ({ apps, onAppClick, onInfoClick, isLoading }) => {
  if (isLoading) {
    return (
      <div className="app-grid-loading">
        <div className="loading-spinner"></div>
        <p>Loading your applications...</p>
      </div>
    );
  }

  if (apps.length === 0) {
    return (
      <div className="app-grid-empty">
        <div className="empty-icon">🔍</div>
        <h3>No applications found</h3>
        <p>Try adjusting your filters or search terms</p>
      </div>
    );
  }

  return (
    <div className="app-grid">
      {apps.map((app) => (
        <AppCard
          key={app.id}
          app={app}
          onClick={onAppClick}
          onInfoClick={onInfoClick}
        />
      ))}
    </div>
  );
};

export default AppGrid;